export default __webpack_public_path__ + "static/teamalert-logo.dbc09c16.svg";